module.exports = require('./dist/react_16_8.js');
